module.exports = function (elm) {
    return {
        props: {
            ports: {
                type: Function,
                required: false
            },
            flags: {
                type: Object,
                required: false
            }
        },
        render: function (createElement) {
            return createElement('div')
        },
        mounted: function () {
            const node = this.$el;
            const app = elm.init({
                node: node,
                flags: this.$props.flags
            });
            if (this.$props.ports) {
                this.$props.ports(app.ports);
            }
        }
    }
}